import { Button, Col, Form, Row, Select, Space, message } from "antd";
import { useMemo, useState } from "react";
import FileUpload from "../common/fileUploadComponent";
import { UploadOutlined } from "@ant-design/icons";
import { useDepartments } from "../../hooks/department/departmentQuery";
import { useFetchAllFinancialYears } from "../../hooks/financialYear/financialYearQuery";
import {useUploadBudgets, useUploadProjections} from "../../hooks/budget/budgetQuery";

const { Option } = Select;

export default function UploadProjections({ onUpload, }) {
    const [file, setFile] = useState(null)
    const [department, setDepartment] = useState(null)
    const [year, setYear] = useState(null)

    const { years } = useFetchAllFinancialYears();
    const { departments } = useDepartments();

    const uploadBudget = useUploadProjections()

    const disableButton = useMemo(() => {
        return !file || !year || !department
    }, [file, year, department])

    const onRead = (f) => {
        setFile(f)
    }

    const formats = ["csv"]

    const uploadFile = async () => {
        const formData = new FormData();
        formData.append("file", file)
        formData.append("department", department)
        formData.append("year", year)
        const d = await uploadBudget(formData)
        d && message.success("Record uploaded successfully")
        onUpload && onUpload()
    }

    return (
        <>
            <Form>
                <Row gutter={2}>
                    <Col span={12}>
                        <Form.Item>
                            <Select placeholder='Select financial year' onChange={(e) => setYear(e)}>
                                {
                                    years.map((y, idx) => (
                                        <Option value={y.id} key={idx}>{y.value}</Option>
                                    ))
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={12} >
                        <Select placeholder="department" onChange={(e) => setDepartment(e)} style={{ width: "100%" }}>
                            {
                                departments.map((s, idx) => (
                                    <Option key={idx} value={s.id}>{s.title}</Option>
                                ))
                            }
                        </Select>
                    </Col>
                </Row>
                <Form.Item>
                    <   FileUpload formats={formats} cb={onRead}></FileUpload>
                </Form.Item>
            </Form>
            <Space
                style={{
                    display: 'flex',
                    marginBottom: 8,
                    marginTop: 4,
                    width: '100%',
                    justifyContent: 'flex-end'
                }}
                align="baseline"
            >

                <Button disabled={disableButton} style={{ backgroundColor: "green", color: "#FFFFFF" }} onClick={uploadFile}>
                    <UploadOutlined />
                    Upload
                </Button>
            </Space>
        </>
    )
}
